module.exports = __webpack_public_path__ + "assets/202509252035/img/less15.0cf0d13b.png";